type version = "" | "/v2"

export enum VERSIONS {
	v1 = "",
	v2 = "/v2",
}

const TRANSACTIONAL = "/transactional"
const CUSTOMER_BEHAVIOR = "/customer-behavior"
const PERFORMANCE = "/performance"
const FILTERS = "/filters"
const LOYALTY = "/loyalty"
const BENCHMARK = "/commercial-benchmark"
const GROWTH = "/growth-profiling"
const CROSS_SELLING = "/cross-selling"
const SWITCHING = "/switching"
const CUSTOMER_PROFILING = "/customer-profiling"

export const getEndpoints = (version: version = "") => ({
	transactional: {
		benchmark: {
			breakdown: TRANSACTIONAL + BENCHMARK + version + "/breakdown",
			timeline: {
				metric: TRANSACTIONAL + BENCHMARK + version + "/timeline",
				growth: TRANSACTIONAL + BENCHMARK + version + "/timeline/growth",
			},
			summary: TRANSACTIONAL + BENCHMARK + version + "/summary",
			vsm: TRANSACTIONAL + BENCHMARK + version + "/vsmbreakdown",
			reach: TRANSACTIONAL + BENCHMARK + version + "/reach",
		},
		growth: {
			_: TRANSACTIONAL + GROWTH + version,
			customer_segmentation:
				TRANSACTIONAL + GROWTH + version + "/customers-segmentation",
		},
		cross_selling: {
			ranking: TRANSACTIONAL + CROSS_SELLING + version + "/ranking",
		},
		sellout: "/reports" + version + "/sellout-reports",
	},
	customer_behavior: {
		loyalty: {
			benchmark: PERFORMANCE + LOYALTY + version + "/benchmark",
			sales_evolution: PERFORMANCE + LOYALTY + version + "/sales-evolution",
			sales_breakdown: PERFORMANCE + LOYALTY + version + "/sales-breakdown",
			loyalty_details: PERFORMANCE + LOYALTY + version + "/loyalty-details",
			sales_info_message:
				PERFORMANCE + LOYALTY + version + "/sales-info-message",
		},
		switching: {
			tree: CUSTOMER_BEHAVIOR + SWITCHING + version + "/tree",
			sankey: CUSTOMER_BEHAVIOR + SWITCHING + version + "/sankey",
			breakdown: CUSTOMER_BEHAVIOR + SWITCHING + version + "/breakdown",
			validate: "/validate-data",
		},
		customer_profiling: {
			chart: CUSTOMER_BEHAVIOR + CUSTOMER_PROFILING + version + "/chart",
			timeline: CUSTOMER_BEHAVIOR + CUSTOMER_PROFILING + version + "/timeline",
			table: {
				age: CUSTOMER_BEHAVIOR + CUSTOMER_PROFILING + version + "/table/age",
				gender:
					CUSTOMER_BEHAVIOR + CUSTOMER_PROFILING + version + "/table/gender",
				psychographics:
					CUSTOMER_BEHAVIOR +
					CUSTOMER_PROFILING +
					version +
					"/table/psychographics",
			},
		},
	},
	filters: {
		vendor: FILTERS + version + "/vendor",
		departments: FILTERS + version + "/departments",
		categories: FILTERS + version + "/categories",
		subcategories: FILTERS + version + "/subcategories",
		fineline: FILTERS + version + "/fineline",
		brands: FILTERS + version + "/brands",
		product: FILTERS + version + "/product",
		format: FILTERS + version + "/format",
		region: FILTERS + version + "/region",
		county: FILTERS + version + "/county",
		store: FILTERS + version + "/store",
	},
	customer_information: "/customer-information" + version,
})
